import { router } from 'expo-router';
import React from 'react';
import { useIntl } from 'react-intl';

import { Button, VStack } from '@fhs-legacy/universal-components';
import { useIsDesktopBp } from 'hooks/breakpoints';
import { usePypestreamContext } from 'state/pypestream';
import { useFlag } from 'utils/launchdarkly';
import { routes } from 'utils/routing';

import { OrderIssuesContainer, OrderIssuesHeading, OrderIssuesText } from './styled';

const OrderIssues: React.FC<React.PropsWithChildren<{ onSupportClick?: VoidFunction }>> = ({
  children,
  onSupportClick,
}) => {
  const { formatMessage } = useIntl();
  const enablePypestream = useFlag('enable-pypestream');
  const { setRedirectToHomePage } = usePypestreamContext();
  const isDesktop = useIsDesktopBp();

  return (
    <OrderIssuesContainer>
      <VStack flex={1} mr="$1">
        <OrderIssuesHeading>{formatMessage({ id: 'needHelp' })}</OrderIssuesHeading>
        <OrderIssuesText>{formatMessage({ id: 'issuesDuringExperience' })}</OrderIssuesText>
        {children}
      </VStack>
      <Button
        variant="outline"
        size="xs"
        onPress={() => {
          /**
           * TODO: When we navigate from cartError to static page, there is no navigation because of that modal
           * appears over staticPage, this callback help us to close the cartError modal in order
           * to make the correct navigation to staticPage. Maybe move away from modal UI to ReactNavigation Modal
           * could help to not use this callback
           */
          onSupportClick?.();
          if (isDesktop && enablePypestream) {
            setRedirectToHomePage(true);
            return router.navigate(routes.base);
          }
          router.navigate(routes.support);
        }}
        _text={{ textTransform: 'capitalize', numberOfLines: 1 }}
      >
        {formatMessage({ id: 'visitSupport' })}
      </Button>
    </OrderIssuesContainer>
  );
};
export default OrderIssues;
